/**
* 分页组件
*/
<template>
  <div class="lyPagination-page">
    <el-pagination class="page-box" small @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="childMsg.page" :page-sizes="pageSizes" :page-size="childMsg.limit" :layout="layout" :total="Number(childMsg.total)"></el-pagination>
    <!-- <el-pagination
      :current-page="childMsg.page"
      :page-size="childMsg.limit"
      :page-sizes="pageSizes"
      small
      :layout="layout"
      :total="childMsg.t"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    /> -->
  </div>
</template>
<script>
  export default {
    name: 'Pagination',
    props: {
      childMsg: { type: Object, default: () => {} },
      pageSizes: { type: Array, default: [10,20,30,40,50,100] },
      layout: { type: String, default: "total, sizes, prev, pager, next, jumper" },
    },
    data() {
      return {
        pageparm: {
          page: this.childMsg.page || 1,
          limit: this.childMsg.limit || 20,
        }
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pageparm.limit = val
        this.pageparm.page = 1
        this.$emit('callFather', this.pageparm)
      },
      handleCurrentChange(val) {
        this.pageparm.page = val
        this.$emit('callFather', this.pageparm)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .lyPagination-page {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #FFFFFF;
    border-top: 1px solid #F2F2F7;
    padding: 8px 16px;
    margin: 0;
    box-shadow: none;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  .page-box {
    text-align: right;

    :deep(.el-pager li) {
      min-width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
      font-size: 13px;
      font-weight: 500;
      color: #1D1D1F;
      background: transparent;
      transition: all 0.15s;

      &:hover { background: #F5F5F7; }

      &.is-active {
        background: #1D1D1F;
        color: #FFFFFF;
        border-radius: 50%;
      }
    }

    :deep(.btn-prev),
    :deep(.btn-next) {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      background: transparent;
      &:hover { background: #F5F5F7; }
    }

    :deep(.el-pagination__total) {
      font-size: 13px;
      color: #6E6E73;
    }

    :deep(.el-pagination__sizes .el-input__wrapper) {
      border-radius: 6px !important;
    }

    :deep(.el-pagination__jump) {
      font-size: 13px;
      color: #6E6E73;
    }
  }
</style>
